import React, { createContext, useContext, useState, useEffect } from 'react';
import { verifyPassword, getStoredPasswordHash } from '../utils/auth';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Check if user is already authenticated on app load
  useEffect(() => {
    const authStatus = localStorage.getItem('myfinbrain_auth');
    if (authStatus === 'authenticated') {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const login = async (password) => {
    try {
      const storedHash = getStoredPasswordHash();

      if (!storedHash) {
        console.error('Admin password hash not configured');
        return { success: false, error: 'Authentication system not configured' };
      }

      const isValid = await verifyPassword(password, storedHash);

      if (isValid) {
        setIsAuthenticated(true);
        localStorage.setItem('myfinbrain_auth', 'authenticated');
        return { success: true };
      } else {
        return { success: false, error: 'Invalid password' };
      }
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error: 'Authentication failed' };
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('myfinbrain_auth');
  };

  const value = {
    isAuthenticated,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
